"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerCreateAccount = void 0;
const React = require("react");
const react_1 = require("react");
const Form_1 = require("../../../../../components/base/forms/Form");
const RetailCustomer_1 = require("../../models/RetailCustomer");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const useClient_1 = require("../../../../../hooks/useClient");
const RetailEventTrackingContext_1 = require("../../contexts/RetailEventTrackingContext");
const signUpMethods_1 = require("../../../../../types/signUpMethods");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const errorTypes_1 = require("../../../../../apis/spg/helpers/errorTypes");
const messages = require("../helpers/text");
const css = (0, cssComposer_1.default)(styles, "RetailCustomerCreateAccount");
const createAccountFormSchema = [
    {
        type: "name",
        required: true,
        label: "Name",
        map: "name",
        placeholder: "John Smith",
        pattern: "[\\w-]+ [\\w'-]+",
        patternMessage: "^Name must have a first and a last name, separated by a space"
    },
    {
        type: "email",
        required: true,
        label: "Email",
        map: "email",
        hideKeypad: true,
        placeholder: "john@example.com",
        remoteCheck: "{servicesUrl}retailCustomers/check-email-validity",
        remoteMessage: "^The given email is either invalid or already used by another account"
    },
    {
        label: "Birth Date",
        type: "date",
        dateFormat: "YYYY-MM-DD",
        map: "birthDate",
        maxDate: "NOW()",
        minDate: "NOW().offset(-99,'years')",
        required: true
    },
    {
        type: "phone",
        required: true,
        label: "Mobile Number",
        map: "mobileNumber",
        hideKeypad: true,
        placeholder: "04XX XXX XXX",
        pattern: "(?:\\+?61|0)[2-478](?:[ -]?[0-9]){8}",
        patternMessage: "^Your phone number must be a valid Australian number",
        description: "A code will be sent to this number to verify your account."
    },
    {
        type: "passwordConfirm",
        required: true,
        label: "Password & Confirm",
        map: "passwordConfirm",
        showStrength: true,
        requiredMessage: "^Your passwords must match",
        remoteCheck: "{servicesUrl}retailCustomers/check-password-strength",
        remoteMessage: messages.passwordStrengthErrorMsg
    },
    {
        label: "I wish to receive news and offers from Zambrero",
        map: "receiveMarketing",
        type: "boolean",
        required: true,
        defaultValue: true
    },
    {
        label: "I agree to the terms and conditions of this service",
        map: "acceptedTerms",
        type: "acceptLegals",
        required: true,
        contentUrl: "https://zam-public-content.s3-ap-southeast-2.amazonaws.com/terms-and-conditions.json"
    }
];
const RetailCustomerCreateAccount = ({ onCompletion }) => {
    const client = (0, useClient_1.useClient)();
    const [error, setError] = (0, react_1.useState)("");
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { logSignUp } = (0, react_1.useContext)(RetailEventTrackingContext_1.RetailEventTrackingContext);
    const onSuccessSignupHandler = (0, react_1.useCallback)(async (value) => {
        // first, clear error messages (if any were previously set)
        setError("");
        const newCustomer = new RetailCustomer_1.RetailCustomer();
        newCustomer.name = value.name;
        newCustomer.mobileNumber = value.mobileNumber;
        newCustomer.email = value.email;
        newCustomer.birthDate = value.birthDate;
        newCustomer.receiveMarketing = value.receiveMarketing;
        try {
            const { id, mobileNumber } = await client.retailCustomers.signupRetailCustomer(newCustomer, value.passwordConfirm, retailLocation.retailLocationId);
            // pass to retailCustomer ID/phone number to parent component
            onCompletion &&
                onCompletion({
                    retailCustomerId: id,
                    mobileNumber
                });
            // log analytic event that the customer has signed up using the email method
            logSignUp && logSignUp(signUpMethods_1.TSignUpMethod.Email);
        }
        catch (e) {
            if (e instanceof errorTypes_1.VerificationCodeError) {
                setError(messages.cannotSendVerificationCodeMsg);
                return;
            }
            if (e instanceof errorTypes_1.ApiUnreachableError) {
                setError(messages.apiUnreachableMsg);
                return;
            }
            setError("Unable to create account. It looks like something went wrong. Please try again.");
            console.error(e);
        }
    }, [onCompletion]);
    return (React.createElement(SlimSection_1.SlimSection, null,
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Register")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            React.createElement(Form_1.Form, { schema: createAccountFormSchema, onSuccess: onSuccessSignupHandler, disableOnSuccess: false, submitLabel: "Sign Up" }),
            error && React.createElement("p", { className: css("error") }, error))));
};
exports.RetailCustomerCreateAccount = RetailCustomerCreateAccount;
//# sourceMappingURL=index.js.map